var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.externalId)?_c('pdf-viewer',{attrs:{"url":`${_vm.apiUrl}common/GetFileStream?externalId=` + `${_vm.externalId}`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }